<script lang="ts">
	import type { SearchField, SearchFieldProps } from 'utility/search-fields'
	import type { InputTypes } from '@isoftdata/svelte-input'
	import type { SvelteSet } from 'svelte/reactivity'

	import Pin from 'components/search/Pin.svelte'
	import Input from '@isoftdata/svelte-input'
	import { createEventDispatcher } from 'svelte'
	import EditModeControls from 'components/search/EditModeControls.svelte'
	import { getEventValue } from '@isoftdata/browser-event'

	interface Props extends SearchFieldProps<string> {
		value?: string

		id?: string
		type?: InputTypes
	}

	let {
		searchField,
		inEditMode,
		pinnedSearchFields,
		selectedSearchFieldsKeys,
		value = $bindable(''),
		disabled = false,
		id = '',
		type = 'text',
		change: changeCb,
	}: Props = $props()

	let disableInput = $derived(disabled || inEditMode)
	const label = $derived(searchField.name ?? '')

	function change(e: Event) {
		value = getEventValue(e)
		changeCb?.({ field: searchField, value })
	}
</script>

<EditModeControls
	{searchField}
	{inEditMode}
	{pinnedSearchFields}
	{selectedSearchFieldsKeys}
>
	<Input
		{id}
		{label}
		{value}
		disabled={disableInput}
		{type}
		onchange={change}
	>
		{#snippet hint()}
			<Pin isPinned={pinnedSearchFields.has(searchField.key)} />
		{/snippet}
	</Input>
</EditModeControls>
